import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
  standalone: true 
})
export class InitialsPipe implements PipeTransform {
  transform(value: { firstName: string; lastName: string }): string {
    if (!value) return '';
    const firstInitial = value.firstName?.charAt(0) || '';
    const lastInitial = value.lastName?.charAt(0) || '';
    return `${firstInitial}${lastInitial}`.toUpperCase();
  }
}